(function() {
    const speakers = document.querySelectorAll(".speakers__speaker")
    speakers.forEach(speaker => {
        const description = speaker.querySelector(".speakers__description")
        if (!description) {
            return
        }
        speaker.querySelector(".speakers__btn--more").addEventListener("click", function() {
            description.classList.remove("speakers__description--collapsed")
        })
        speaker.querySelector(".speakers__btn--less").addEventListener("click", function() {
            description.classList.add("speakers__description--collapsed")
        })
    });
})();